<template>
  <UITooltip text="Share this tracker" placement="bottom">
    <Button
      size="sm"
      variant="secondary"
      icon="ShareIcon"
      class="w-auto"
      aria-label="Share this tracker"
      @click="togglePopover"
    >
      Share
    </Button>
  </UITooltip>

  <Popover ref="popoverRef" class="w-[min(24rem,90vw)]">
    <div class="p-1">
      <div class="mb-3 flex items-center justify-between">
        <h3 class="text-gpx_base text-gpx_black-500 font-semibold">
          Public tracker link
        </h3>
        <button
          type="button"
          aria-label="Close"
          class="text-gpx_gray-200 hover:text-gpx_black-500"
          @click="closePopover"
        >
          <XMarkIcon class="size-[18px]" />
        </button>
      </div>

      <DeviceSharing :device="device" :device-id="deviceId" />
    </div>
  </Popover>
</template>

<script setup>
import { ref } from 'vue';
import Popover from 'primevue/popover';
import DeviceSharing from './DeviceSharing.vue';

defineProps({
  device: {
    type: Object,
    default: null,
  },
  deviceId: {
    type: Number,
    required: true,
  },
});

const popoverRef = ref(null);

const togglePopover = (event) => {
  popoverRef.value?.toggle(event);
};
const closePopover = () => {
  popoverRef.value?.hide();
};
</script>
